<template>
  <div class="hostes-tab-root">
    <div class="dashboard-base-bg">
      <div class="dashboard-sec-bg">
        <!-- Learn more -->
        <div
          v-if="showActivityCard"
          @click="handleLearnMore"
          class="activity-card"
        >
          <div class="card-bg"></div>
          <div class="card-content">
            <MyPLabel
              class="card-info"
              :str="$t('lang.Invite.k021')"
              :numsOption="[{ value: info.actInviteBeanReward, style: '' }]"
              :customClass="{ bean: 'activity-bean' }"
            />
            <div class="date-pill">
              <img class="date-icon" src="@/assets/packageAssets/views/P2_Page/Invite/default/clock.webp" alt="" />
              <span class="date-text">
                {{ handleMoment(info.actInviteStartTimeStamp, 'DD MMM') }} – {{ handleMoment(info.actInviteEndTimeStamp, 'DD MMM YYYY') }}
              </span>
            </div>
          </div>
          <button type="button" class="learn-more">{{ $t('lang.Invite.k022') }}</button>
        </div>

        <div class="hostess-panel">
          <div class="module-switch-tab">
            <div class="module-switch-inner">
              <div class="module-tab" :class="{ 'active-tab': hostModuleTab === 0 }" @click="handleModuleTab(0)">{{ $t('lang.Invite.k059') }}</div>
              <div class="module-tab" :class="{ 'active-tab': hostModuleTab === 1 }" @click="handleModuleTab(1)">
                {{ $t('lang.BaseCommon.k031') }}
              </div>
            </div>
          </div>

          <InviteTab v-if="hostModuleTab === 0" :info="info" />
          <CommissionTab v-if="hostModuleTab === 1" :info="info" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InviteTab from './InviteTab.vue'
import CommissionTab from './CommissionTab.vue'

export default {
  name: 'HostessTab',
  components: { InviteTab, CommissionTab },
  props: {
    info: {
      type: Object,
      default: () => {
        return undefined
      },
    },
  },
  data() {
    return {
      hostModuleTab: 0,
    }
  },
  computed: {
    showActivityCard() {
      const info = this.info
      if (!info?.actInviteBeanReward || !info?.actInviteStartTimeStamp || !info?.actInviteEndTimeStamp) {
        return false
      }
      const now = Date.now()
      return now >= info.actInviteStartTimeStamp && now <= info.actInviteEndTimeStamp
    },
  },
  methods: {
    handleLearnMore() {
      this.$router.push({ path: '/invite-rules', query: { location: 'limitedBonus' } })
    },
    handleModuleTab(index) {
      this.hostModuleTab = index
    },
  },
}
</script>

<style lang="scss" scoped>
.hostes-tab-root {
  .dashboard-base-bg {
    width: 343px;
    margin: auto;
    background: #d0c6b6;
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;

    .dashboard-sec-bg {
      background: #fefefe;
      border-radius: 16px;
      padding: 12px;

      .activity-card {
        position: relative;
        width: 319px;
        margin: 0 auto;
        padding: 13px 12px;
        background: #f3794e;
        border-radius: 8px;
        overflow: hidden;
        box-sizing: border-box;

        .card-bg {
          position: absolute;
          left: 50%;
          top: 50%;
          width: 100%;
          height: 100%;
          transform: translate(-50%, -50%);
          background: url('~@/assets/packageAssets/views/P2_Page/Invite/default/card-bg.webp') center / cover no-repeat;
          mix-blend-mode: hard-light;
          opacity: 0.6;
          pointer-events: none;
        }

        .card-content {
          position: relative;
          z-index: 1;
          display: flex;
          flex-direction: column;

          .date-pill {
            margin-top: 4px;
            display: inline-flex;
            align-items: center;
            max-width: calc(100% - 96px);
            min-width: 0;
            padding-block: 3px;
            padding-inline: 4px 8px;
            background: linear-gradient(90deg, rgba(253, 0, 10, 0.5) 0%, rgba(255, 88, 31, 0) 100%);
            border-radius: 20px;
            box-sizing: border-box;

            .date-icon {
              width: 16px;
              height: 16px;
              margin: 0 2px;
              flex-shrink: 0;
            }

            .date-text {
              margin-inline-start: 2px;
              min-width: 0;
              overflow: hidden;
              text-overflow: ellipsis;
              font-family: var(--string-font);
              font-style: italic;
              font-weight: var(--fw-400);
              font-size: var(--fs-12);
              line-height: var(--lh-label-16);
              color: #ffffff;
              white-space: nowrap;
              direction: ltr;
            }
          }

          .card-info {
            font-family: 'PlusJakartaSans-Regular', var(--string-font);
            font-weight: var(--fw-700);
            font-size: var(--fs-14);
            line-height: var(--lh-title-20);
            color: #ffffff;
            letter-spacing: 0;

            :deep(img),
            :deep(.activity-bean) {
              display: inline-block;
              width: 16px;
              height: 16px;
              vertical-align: middle;
            }
          }
        }

        .learn-more {
          position: absolute;
          inset-inline-end: 12px;
          bottom: 8px;
          z-index: 1;
          padding: 4px 12px;
          border: none;
          background: #fff4c1;
          border-radius: 44px;
          font-family: var(--string-font);
          font-weight: var(--fw-400);
          font-size: var(--fs-14);
          line-height: var(--lh-title-20);
          color: #ed5f48;
          white-space: nowrap;
        }
      }

      .hostess-panel {
        display: flex;
        flex-direction: column;
        margin-top: 12px;

        .module-switch-tab {
          width: 300px;
          margin: 0 auto;
          padding: 8px 0;

          .module-switch-inner {
            display: flex;
            align-items: center;
            background: #eeeae4;
            border-radius: 36px;
          }

          .module-tab {
            flex: 1;
            padding: 10px 12px;
            font-family: var(--string-font);
            font-weight: var(--fw-400);
            font-size: var(--fs-12);
            line-height: var(--lh-title-20);
            color: #a9a092;
            text-align: center;
            white-space: nowrap;

            &.active-tab {
              border: 4px solid #eeeae4;
              border-radius: 24px;
              color: #ffffff;
              background: linear-gradient(180deg, #f6e0b3 0%, #c6a175 42.788%, #86592e 100%);
            }
          }
        }
      }
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .hostes-tab-root {
    .dashboard-base-bg {
      .dashboard-sec-bg {
        .activity-card {
          .card-content {
            .date-pill {
              background: linear-gradient(270deg, rgba(253, 0, 10, 0.5) 0%, rgba(255, 88, 31, 0) 100%);
            }
          }
        }
      }
    }
  }
}
</style>
